var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('page-with-button',{attrs:{"img":require('@/assets/images/butterfly.png'),"title":"Whoops","subtitle":"Sorry, we can't find that page! Don’t worry though, everything is still AWESOME!"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }